import React from "react";
import {
    Grid,
    makeStyles,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import DefinedWaitingOpponent from "../components/DefinedWaitingOpponent";
import UserInfo from "../../model/userInfo";
// import UndefinedWaitingOpponent from "../components/UndefinedWaitingOpponent";

const useStyles = makeStyles(() => ({
    fullHeight: {
        height: "100%",
    },
    bold: {
        fontWeight: "bold",
    },
}));

type WaitingScreenProps = {
    user?: UserInfo;
    backButton?: boolean,
}

export default function WaitingLoading({ user, backButton  }: WaitingScreenProps): JSX.Element {
    const classes = useStyles();
    let avatar;

    if (user !== undefined) {
        avatar = <DefinedWaitingOpponent user={user} backButton={backButton || false} />;
    }

    return (
        <MainScreen lower={false} back={backButton}>
            <Grid container direction="column" justify="space-around" classes={{ root: classes.fullHeight }}>
                {avatar}
            </Grid>
        </MainScreen>
    );
}
